export const TireOfferHomeSkeleton = () => (
  <div className='flex animate-pulse flex-col gap-5'>
    <StatStripSkeleton />
    <TabsRowSkeleton />
    <ModeBannerSkeleton />
    <TableSkeleton />
  </div>
);

const StatStripSkeleton = () => (
  <div className='grid grid-cols-2 gap-3 md:grid-cols-4'>
    {[0, 1, 2, 3].map((index) => (
      <div key={index} className='flex flex-col gap-2 rounded-xl border border-border bg-skeleton/40 p-4'>
        <div className='h-3 w-20 rounded-sm bg-skeleton' />
        <div className='h-7 w-16 rounded-sm bg-skeleton' />
        <div className='h-3 w-24 rounded-sm bg-skeleton' />
      </div>
    ))}
  </div>
);

const TabsRowSkeleton = () => (
  <div className='relative flex items-center'>
    <div className='flex gap-2 rounded-lg bg-skeleton/40 p-[3px]'>
      <div className='h-7 w-24 rounded-md bg-skeleton/40' />
      <div className='h-7 w-24 rounded-md' />
    </div>
    <div className='absolute top-0 right-0 hidden h-9 w-56 rounded-lg bg-skeleton/40 md:block' />
  </div>
);

const ModeBannerSkeleton = () => (
  <div className='flex items-center gap-3 rounded-lg border border-border bg-skeleton/40 p-4'>
    <div className='size-8 shrink-0 rounded-lg bg-skeleton' />
    <div className='flex flex-1 flex-col gap-2'>
      <div className='h-4 w-40 rounded-sm bg-skeleton' />
      <div className='h-3 w-3/4 rounded-sm bg-skeleton' />
    </div>
  </div>
);

const TableSkeleton = () => (
  <div className='overflow-hidden rounded-xl border border-border bg-skeleton/40'>
    <div className='hidden grid-cols-[28px_minmax(180px,220px)_1fr_minmax(110px,140px)] items-center gap-4 border-b border-border bg-skeleton/40 px-4 py-2.5 md:grid'>
      <div />
      <div className='h-3 w-32 rounded-sm bg-skeleton' />
      <div className='grid grid-cols-3 gap-2'>
        <div className='h-3 w-16 rounded-sm bg-skeleton' />
        <div className='h-3 w-16 rounded-sm bg-skeleton' />
        <div className='h-3 w-16 rounded-sm bg-skeleton' />
      </div>
      <div className='ml-auto h-3 w-12 rounded-sm bg-skeleton' />
    </div>
    {[0, 1, 2].map((index) => (
      <div
        key={index}
        className='grid grid-cols-[28px_minmax(180px,220px)_1fr_minmax(110px,140px)] items-center gap-4 border-b border-border p-4 last:border-b-0'
      >
        <div className='size-[18px] rounded-md border-2 border-border' />
        <div className='flex flex-col gap-2'>
          <div className='h-4 w-32 rounded-sm bg-skeleton' />
          <div className='h-3 w-24 rounded-sm bg-skeleton' />
        </div>
        <div className='grid grid-cols-3 gap-2'>
          <div className='h-20 rounded-lg bg-skeleton' />
          <div className='h-20 rounded-lg bg-skeleton' />
          <div className='h-20 rounded-lg bg-skeleton' />
        </div>
        <div className='ml-auto h-5 w-20 rounded-sm bg-skeleton' />
      </div>
    ))}
  </div>
);
